import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';

import { EmployeeService } from '../../services/employee.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { JobService } from '../../services/job.service';
import { RoleService } from '../../services/role.service';
import { CheckClockService } from '../../services/check-clock.service';
import { DepartmentService } from '../../services/department.service';

import { Utils } from '../../util';
import { QRCodeComponent } from 'angularx-qrcode';
import { Upload } from '../../services/upload/upload';

function notRequiredEmailValidator(control: FormControl) {
    if (!control.value) {
        return null;
    }

    return Validators.email(control);
}

@Component({
    selector: 'app-create-employee',
    templateUrl: './create-employee.component.html',
    styleUrls: ['./create-employee.component.css', '../../app.component.css']
})

export class CreateEmployeeComponent implements OnInit, OnDestroy {

    id: string = '';

    @ViewChild('qrCode') qrDiv: QRCodeComponent;
    get qrData(): string { return `Id: ${this.id}\nLlave interna: ${this.employeeForm.get('internalKey').value}\nNombre: ${this.employeeForm.get('name').value} ${this.employeeForm.get('lastName').value}` };

    employeeForm: FormGroup;
    employee: any;
    appliesBonus: boolean = false;

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    roles = {};
    roleInit: any;
    roleText = '';

    jobs = {};
    jobInit: any;
    jobText = '';

    departments = {};
    departmentInit: any;
    departmentText = '';

    pickadateParams = Utils.pickadateParams();

    modalActions = new EventEmitter<string|MaterializeAction>();
    modalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    jobForm: FormGroup;
    job: any;

    transportArriveVal: number;
    carriers = {};
    carrierInit: any;
    carrierText = '';

    gsSubs: any;
    grSubs: any;
    geSubs: any;
    gjSubs: any;
    gccbfSubs: any;
    gdSubs: any;

    savingFlag = false;

    applyInPrompterReportVal = false;
    applyInSupervisorReportVal = false;
    applyInCheckClockVal = false;
    applySecurityReportVal = false;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private service: EmployeeService,
        private subsidiaryService: SubsidiaryService,
        private jobService: JobService,
        private roleService: RoleService,
        private checkClockService: CheckClockService,
        private departmentService: DepartmentService
    ) {
        this.id = service.generateId();
        this.transportArriveVal = 0;

        this.loadSubsidiariesAndRolesAndCarriersAndDepartments();
        this.loadJobs();
    }

    ngOnInit() {
        this.employeeForm = this.formBuilder.group({
            name: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', notRequiredEmailValidator],
            cellPhone: '',
            extPhone: '',
            admissionDate: '',
            internalKey: '',
            subsidiary: ['', Validators.required],
            role: '',
            job: ['', Validators.required],
            department: '',
            transportArrive: ['', Validators.required],
            carrier: '',
            applyInPrompterReport: '',
            applyInSupervisorReport: '',
            applyInCheckClock: '',
            applySecurityReport: '',
        });

        this.jobForm = this.formBuilder.group({
            nameJob: ['', Validators.required],
            descriptionJob: ['', Validators.required],
            internalNumberJob: ['', Validators.required],
            baseSalaryJob: ['', [Validators.required, Validators.pattern('[0-9]+(\.[0-9][0-9]?)?')]]
        });
    }

    onSubmitEmployee() {
        this.savingFlag = true;

        this.employee = this.saveEmployee();

        this.service.postEmployee(this.employee, this.id).then(() => {
            this.uploadQR();
            if (this.employee.internalKey !== null && this.employee.internalKey !== '' && this.employee.internalKey !== 0) {
                const self = this;

                this.gccbfSubs = this.checkClockService.getCheckClocksByFolio(this.employee.internalKey).subscribe(tempCheckClocks => {
                    this.gccbfSubs.unsubscribe();

                    const recordsToBatch = [];
                    const currentDate = new Date();

                    for (let idx in tempCheckClocks) {
                        const checkClockJson = {
                            id: tempCheckClocks[idx].id$,
                            employeeId: this.id,
                            updatedAt: currentDate
                        };

                        recordsToBatch.push(checkClockJson);
                    }

                    this.checkClockService.putCheckClockAtomic(recordsToBatch).then(function() {
                        self.employeeForm.reset();
                        self.router.navigate([`/vw_employee/${self.id}`]);
                    });
                });
            } else {
                this.employeeForm.reset();
                this.router.navigate([`/vw_employee/${this.id}`]);
            }
        });
    }

    saveEmployee() {
        let admissionDate: any;
        if (this.employeeForm.get('admissionDate').value) {
            admissionDate = Utils.convertDatefromISOStringtoObject(this.employeeForm.get('admissionDate').value);
        } else {
            admissionDate = '';
        }

        const transportArrive = +this.employeeForm.get('transportArrive').value;
        let carrierId: string;
        if (Math.floor(transportArrive) === 3) {
            carrierId = this.carriers[this.employeeForm.get('carrier').value];
        } else {
            carrierId = '';
        }

        const currentDate = new Date();

        let roleId = '';
        if (this.employeeForm.get('role').value) {
            roleId = this.roles[this.employeeForm.get('role').value];
        }

        let departmentId = '';
        if (this.employeeForm.get('department').value) {
            departmentId = this.departments[this.employeeForm.get('department').value];
        }

        const employeeJson = {
            active: 1,
            activityId: this.jobs[this.employeeForm.get('job').value],
            admissionDate: admissionDate,
            applyInCheckClock: this.employeeForm.get('applyInCheckClock').value,
            applyInPrompterReport: this.employeeForm.get('applyInPrompterReport').value,
            applyInSupervisorReport: this.employeeForm.get('applyInSupervisorReport').value,
            applySecurityReport: this.employeeForm.get('applySecurityReport').value,
            carrierId: carrierId,
            createdAt: currentDate,
            email: this.employeeForm.get('email').value,
            cellPhone: this.employeeForm.get('cellPhone').value,
            extPhone: this.employeeForm.get('extPhone').value,
            //imageUrl: '',
            internalKey: this.employeeForm.get('internalKey').value,
            lastName: this.employeeForm.get('lastName').value,
            name: this.employeeForm.get('name').value,
            //password: '',
            roleId: roleId,
            //salt: '',
            subsidiaryId: this.subsidiaries[this.employeeForm.get('subsidiary').value],
            //token: '',
            transportArrive: transportArrive,
            updatedAt: currentDate,
            departmentId: departmentId,
            appliesBonus: !!this.appliesBonus
        };

        return employeeJson;
    }

    uploadQR(){
        //https://github.com/cordobo/angularx-qrcode#parameters
        let blob: any;
        let xhr = new XMLHttpRequest();
        xhr.open("GET", this.qrDiv.qrcode._oDrawing._elImage.currentSrc);
        xhr.responseType = "blob";
        xhr.onload = () => {
            blob = xhr.response;
            blob.name = 'webcamPicture.jpeg';
            let file: File = <File> blob;
            var currentUpload: Upload = new Upload(file);
            this.service.uploadQR(currentUpload, this.id);
        };
        xhr.send();
    }

    loadSubsidiariesAndRolesAndCarriersAndDepartments() {
        this.gsSubs = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const dataSubsidiary = {};

            for (const idx in tempSubsidiaries) {
                dataSubsidiary[tempSubsidiaries[idx].name] = null;
                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': dataSubsidiary,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.subsidiaries[val]);
                }
            };
        });

        this.grSubs = this.roleService.getRoles().subscribe(tempRoles => {
            const dataRole = {};

            for (const idx in tempRoles) {
                dataRole[tempRoles[idx].name] = null;
                this.roles[tempRoles[idx].name] = tempRoles[idx].id$;
            }

            this.roleInit = {
                'data': dataRole,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.roles[val]);
                }
            };
        });

        this.geSubs = this.service.getEmployees().subscribe(tempEmployees => {
            const dataEmployee = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                dataEmployee[employeeDisplayValue] = null;
                this.carriers[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.carrierInit = {
                'data': dataEmployee,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.carriers[val]);
                }
            };

            this.carrierText = tempEmployees[0] ? `${tempEmployees[0].name} ${tempEmployees[0].lastName}` : '';
        });

        this.gdSubs = this.departmentService.getDepartments().subscribe(tempDepartments => {
            const dataDepartment = {};

            for (const idx in tempDepartments) {
                dataDepartment[tempDepartments[idx].name] = null;
                this.departments[tempDepartments[idx].name] = tempDepartments[idx].id$;
            }

            this.departmentInit = {
                'data': dataDepartment,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.departments[val]);
                }
            };
        });
    }

    loadJobs() {
        this.gjSubs = this.jobService.getJobs().subscribe(tempJobs => {
            const dataJob = {};

            for (const idx in tempJobs) {
                dataJob[tempJobs[idx].name + ' - ' + tempJobs[idx].baseSalary] = null;
                this.jobs[tempJobs[idx].name + ' - ' + tempJobs[idx].baseSalary] = tempJobs[idx].id$;
            }

            this.jobInit = {
                'data': dataJob,
                onAutocomplete: (val) => { // console.log(val); // console.log(this.jobs[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

    onBlurRole() {
        if (this.roles[this.roleText] === undefined) {
            this.roleText = '';
        }
    }

    onBlurJob() {
        if (this.jobs[this.jobText] === undefined) {
            this.jobText = '';
        }
    }

    onBlurDepartment() {
        if (this.departments[this.departmentText] === undefined) {
            this.departmentText = '';
        }
    }

    onBlurCarrier() {
        if (this.carriers[this.carrierText] === undefined) {
            this.carrierText = '';
        }
    }

    openModal() {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeModal() {
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    }

    onSubmitJob() {
        this.job = this.saveJob();

        this.jobService.postJob(this.job).then(res => {
            this.jobForm.reset();

            this.loadJobs();

            this.closeModal();

            this.jobText = this.job.name + ' - ' + this.job.baseSalary;
        });
    }

    saveJob() {
        const currentDate = new Date();

        const jobJson = {
            active: true,
            baseSalary: this.jobForm.get('baseSalaryJob').value,
            createdAt: currentDate,
            description: this.jobForm.get('descriptionJob').value,
            internalNumber: this.jobForm.get('internalNumberJob').value,
            name: this.jobForm.get('nameJob').value,
            subsidiaryId: this.subsidiaries[this.employeeForm.get('subsidiary').value],
            updatedAt: currentDate
        };

        return jobJson;
    }

    ngOnDestroy() {
        this.gsSubs.unsubscribe();
        this.grSubs.unsubscribe();
        this.geSubs.unsubscribe();
        this.gjSubs.unsubscribe();
        this.gdSubs.unsubscribe();
    }

}
